import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/Observable';

import { AuthenticationService } from './authentication.service';
import { LoginComponent } from '../login/login.component';
import { PublicAccessTerminalService } from './public-access-terminal.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authenticationService: AuthenticationService,
                private modalService: BsModalService,
                private publicAccessTerminalService: PublicAccessTerminalService,
                private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        // return true if already logged in
        if (this.authenticationService.isUserLoggedIn()) {
            return true;
        }

        const isPublicAccessTerminal = this.publicAccessTerminalService.isPublicAccessTerminal();
        if (isPublicAccessTerminal) {
            return this.authenticationService.authenticateViaClientCertificate()
                .then(success => {
                    if (!success) {
                        this.router.navigate(['/public_access_terminal']); // note that they may already be on this route
                    }
                    return success;
                });
        }

        // This would be used when entering the application from single sign on or redirecting from auth server
        if (this.doesUrlContainAccessToken(state.url)) {
            return this.handleAccessToken(state.url);
        }

        return this.showLoginPrompt();
    }

    private showLoginPrompt(): Promise<boolean> {
        // not logged in so route to 'login' and return false
        const bsModalRef = this.modalService.show(LoginComponent, {class: 'modal-lg', backdrop: 'static'});
        return new Promise<boolean>((resolve, reject) => {
            bsModalRef.content.loginCompleted$.subscribe(value => {
                resolve(value);
                bsModalRef.hide();
            });
        });
    }

    private doesUrlContainAccessToken(url: string) {
        return url.indexOf('access_token') !== -1;
    }

    private handleAccessToken(url: string): Promise<boolean> {
        const hash = url.substr(url.indexOf('#'));
        window.location.hash = ''; // strip off the hash (which shows the access token)
        return this.authenticationService.processOAuthHash(hash);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/auth-guard.ts